import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthedContext } from './AuthedContext';
import { BasicLoading } from './components/BasicLoading';
import * as PlatformPages from './platform-app/platform-pages';
import { PlatformTemplate } from './platform-app/template';
import * as ProgramPages from './program-app/program-pages';
import { ProgramTemplate } from './program-app/template';
import * as ReportingPages from './reporting-app/reporting-pages';
import { ReportingTemplate } from './reporting-app/template';

export function SignedInRouter() {
  return (
    <Suspense fallback={<BasicLoading />}>
      <Routes>
        {/* All the authed apps are wrapped in the AuthedContext, which provides the user context and tracking. */}
        <Route element={<AuthedContext />}>
          {/* New platform pages */}
          <Route path="platform" element={<PlatformTemplate />}>
            <Route path="use-cases" element={<PlatformPages.UseCasesPage />} />
            <Route path="use-cases/new" element={<PlatformPages.UseCasePromptBuilderPage />} />
            <Route
              path="use-cases/seed/:seedUuid"
              element={<PlatformPages.UseCasePromptBuilderPage />}
            />
            <Route
              path="use-cases/template/:templateUuid"
              element={<PlatformPages.UseCasePromptBuilderPage />}
            />
            <Route index element={<PlatformPages.HomePage />} />
          </Route>

          {/* Umbrella for a reporting pages */}
          <Route path="reporting" element={<ReportingTemplate />}>
            <Route path="progress" element={<ReportingPages.ProgressReport />} />
            <Route path="nps" element={<ReportingPages.NpsReport />} />
          </Route>

          {/* The guided ProfAI experience */}
          <Route element={<ProgramTemplate />}>
            <Route path="profile" element={<ProgramPages.ProfilePage />} />
            <Route path="/p/" element={<ProgramPages.OnboardingOutlet />}>
              <Route index element={<ProgramPages.HomePage />} />
              <Route path="/p/:programSlug" element={<ProgramPages.ProgramBySlug />} />
              <Route path="/p/:programSlug/s/:skillSlug" element={<ProgramPages.SkillLesson />} />
            </Route>
            <Route path="/demo/p/:programSlug/s/:skillSlug" element={<ProgramPages.UserTest />} />
            <Route
              path="/demo/p/:programSlug/s/:skillSlug/t/:toolName"
              element={<ProgramPages.UserToolTest />}
            />
            <Route
              path="/demo/p/:programSlug/s/:skillSlug/c/:competencySlug/t/:toolName"
              element={<ProgramPages.UserToolTest />}
            />
            <Route
              path="/demo/p/:programSlug/s/:skillSlug/c/:competencySlug/e/:exerciseSlug"
              element={<ProgramPages.UserToolExerciseTest />}
            />
            <Route
              path="/practice/p/:programSlug/s/:skillSlug/c/:competencySlug/e/:exerciseSlug"
              element={<ProgramPages.ExercisePracticePage />}
            />
            <Route path="*" element={<Navigate to="/p" replace />} />
          </Route>
        </Route>
      </Routes>
    </Suspense>
  );
}
